/* global Swiper */
import Abstract from '../abstract';
import { onSendGTag } from '../module';

const JP_TEXT = {
  swipe: 'スワイプ',
  pagination: 'ページネーション',
  list: 'リスト',
  next: '次',
  prev: '前',
  tap: 'タップ',
};

const swiperInit = (parentEl, options) => {
  const container = parentEl.querySelector('.swiper');

  return new Swiper(container, options);
};

const labelForChangePhotoGTag = (type, direction) => {
  const typeLabel = JP_TEXT[type] || type;
  const directionLabel = JP_TEXT[direction] || direction;

  return `${typeLabel}_${directionLabel}`;
};

const onSendClickBackToArticleButtonLinkGTag = (event) => {
  onSendGTag('タップ', {
    event_category: '画像ページ記事に戻る',
    event_label: 'タップ',
    link_url: event.currentTarget.getAttribute('href'),
  });
};

const onSendClickListImageButtonLinkGTag = () => {
  onSendGTag('タップ', {
    event_category: '画像ページ写真一覧へ',
    event_label: 'タップ',
  });
};

const onSendClickArticleRankingLinkGTag = (event, index) => {
  onSendGTag('タップ', {
    event_category: '画像ページランキング',
    event_label: index,
    link_url: event.currentTarget.getAttribute('href'),
  });
};

const onSendChangePhotoGTag = (type, direction) => {
  if (!type || !direction) {
    return;
  }

  onSendGTag('タップ', {
    event_category: '画像ページ_画像スライド',
    event_label: labelForChangePhotoGTag(type, direction),
  });
};

export default class ArticlePhotoView extends Abstract {
  init() {
    this.getElement();
    this.initSwiper();
    this.addEvent();
  }

  getElement() {
    this.articlePhotoCarouselContainer = document.querySelector('.js-article-photo-image-carousel-container');
    this.articlePhotoCarouselPagination = document.querySelector('.js-article-photo-image-carousel-pagination');
    this.articlePhotoBackButtonLinks = document.querySelectorAll('.js-article-photo-image-container-back-button');
    this.articlePhotosImagesSection = document.querySelector('.js-article-photo-images-section');
    this.articlePhotosListImageButtons = document.querySelectorAll('.js-article-photo-list-image-button');
    this.articlePhotos = document.querySelector('.js-article-photo-images-list');
    this.articlePhotoRankingLinks = document.querySelectorAll('.js-article-photo-ranking-link');
  }

  getCarouselPhotoId() {
    if (!this.articlePhotoCarouselContainerSwiper) {
      return undefined;
    }

    const { activeIndex, slides } = this.articlePhotoCarouselContainerSwiper;
    const currentArticlePhotoElement = slides[activeIndex];
    return currentArticlePhotoElement.dataset.id;
  }

  // eslint-disable-next-line class-methods-use-this
  getParamsArticlePhotoIds() {
    const { pathname } = window.location;
    const [articleId, photoId] = pathname.match(/(\d+)/gm);

    return [articleId, photoId];
  }

  updateArticlePhotoItemStyle(currentArticlePhotoId) {
    if (!this.articlePhotos) {
      return;
    }

    this.articlePhotos.querySelectorAll('.js-article-photo-images-item').forEach((imageElement) => {
      if (imageElement.dataset.id === currentArticlePhotoId) {
        imageElement.classList.add('article-photo-Images_Item-Current');
        return;
      }

      imageElement.classList.remove('article-photo-Images_Item-Current');
    });
  }

  updateCurrentArticlePhotoCarousel(photoId) {
    const { slides } = this.articlePhotoCarouselContainerSwiper || { slides: [] };
    slides.forEach((slide) => {
      const { id, swiperSlideIndex } = slide.dataset || {};
      if (id === photoId && swiperSlideIndex) {
        this.articlePhotoCarouselContainerSwiper.slideToLoop(swiperSlideIndex);
      }
    });
  }

  initSwiper() {
    if (!this.articlePhotoCarouselContainer) {
      return;
    }

    const { currentImageId: currentArticlePhotoId } = this.articlePhotoCarouselContainer.dataset;
    const articlePhotoCarousels = this.articlePhotoCarouselContainer.querySelectorAll(
      '.js-article-photo-image-carousel-slide',
    );
    let currentArticlePhotoCarouselIndex = 0;

    articlePhotoCarousels.forEach((imageElement, imageElementIndex) => {
      if (imageElement.dataset.id === currentArticlePhotoId) {
        currentArticlePhotoCarouselIndex = imageElementIndex;
      }
    });

    this.articlePhotoCarouselContainerSwiper = swiperInit(this.articlePhotoCarouselContainer, {
      slidesPerView: 'auto',
      loop: true,
      centeredSlides: true,
      initialSlide: currentArticlePhotoCarouselIndex,
      navigation: {
        prevEl: '.js-article-photo-image-carousel-navigation-prev',
        nextEl: '.js-article-photo-image-carousel-navigation-next',
      },
      pagination: {
        el: '.js-article-photo-image-carousel-pagination',
        clickable: true,
        type: 'fraction',
        renderFraction: function (currentClass, totalClass) {
          return '<span class="swiper-pagination-arrow">&lt;</span> <span class="' + currentClass + '"></span> / <span class="' + totalClass + '"></span> <span class="swiper-pagination-arrow">&gt;</span>';
        },
      },
      on: {
        init: () => {
          this.articlePhotoCarouselContainer.classList.add('article-photo-ImageCarousel_Container-visible');
          this.updateArticlePhotoItemStyle(currentArticlePhotoId);
        },
        touchEnd: () => {
          if (!this.articlePhotoCarouselContainerSwiper) {
            return;
          }

          const { swipeDirection } = this.articlePhotoCarouselContainerSwiper;
          onSendChangePhotoGTag('swipe', swipeDirection);
        },
        slideChange: () => {
          if (!this.articlePhotoCarouselContainerSwiper) {
            return;
          }

          this.updateArticlePhotoItemStyle(this.getCarouselPhotoId());
        },
        slideChangeTransitionEnd: () => {
          const carouselPhotoId = this.getCarouselPhotoId();
          const [paramsArticleId, paramsPhotoId] = this.getParamsArticlePhotoIds();

          if (!carouselPhotoId || !paramsPhotoId || carouselPhotoId === paramsPhotoId) {
            return;
          }

          const { pathname } = window.location;
          const currentPathname = pathname.replace(`photos/${paramsPhotoId}`, `photos/${carouselPhotoId}`);
          window.history.pushState({
            paramsArticleId,
            paramsPhotoId,
          }, '', currentPathname);
        },
      },
    });
  }

  addEvent() {
    if (this.articlePhotoCarouselPagination) {
      this.articlePhotoCarouselPagination.addEventListener('click', () => {
        onSendChangePhotoGTag('pagination', 'tap');
      });
    }

    if (this.articlePhotos) {
      this.articlePhotos.querySelectorAll('.js-article-photo-images-item').forEach((imageElement) => {
        imageElement.addEventListener('click', (event) => {
          onSendChangePhotoGTag('list', 'tap');
          this.updateCurrentArticlePhotoCarousel(event.currentTarget.dataset.id);
        });
      });
    }

    if (this.articlePhotoBackButtonLinks) {
      this.articlePhotoBackButtonLinks.forEach((element) => {
        element.addEventListener('click', onSendClickBackToArticleButtonLinkGTag);
      });
    }

    if (this.articlePhotosListImageButtons) {
      this.articlePhotosListImageButtons.forEach((element) => {
        element.addEventListener('click', () => {
          if (!this.articlePhotosImagesSection) {
            return;
          }

          this.articlePhotosImagesSection.scrollIntoView({ behavior: 'smooth' });
          onSendClickListImageButtonLinkGTag();
        });
      });
    }

    this.articlePhotoRankingLinks.forEach((element, index) => {
      element.addEventListener('click', (event) => onSendClickArticleRankingLinkGTag(event, index + 1));
    });

    window.addEventListener('popstate', () => {
      const [, photoId] = this.getParamsArticlePhotoIds();
      this.updateCurrentArticlePhotoCarousel(photoId);
    });
  }
}
